import { XMarkIcon } from "@heroicons/react/20/solid";
import { format } from "date-fns";
import _ from "lodash";
import { useEffect } from "react";
import { connect } from 'react-redux';
import { Actions as ADVISORACTIONS } from '../../store/actions/advisorActions';
import { Actions as PAYMENTACTIONS } from '../../store/actions/paymentActions';
import AdvisorBundleCard from '../billing/AdvisorBundleCard';
import PaymentMethods from '../common/payments/PaymentMethods';


const AdvisorChoosePlan = ({
  getBundles,
  showModal,
  closeModal,
  selectBundle,
    updateAdvisorDetails,
  bundles,
  advisorBundles,
  recommended,
  selectedBundle,
    advisorId,
  creditsNeeded,
  isAdvisor
}) => {

  useEffect(() => {
    getBundles()
  }, []);


  useEffect(() => {

    if (recommended) {
      // scroll to middle
    }

  }, [recommended]);

  if (!showModal || !bundles) {
    return null
  }

  /*if (selectedBundle) {
    return (
      <div className="modal" tabIndex="-1" role="dialog" aria-hidden="true" style={{
        display: "block", background: "rgba(0,0,0,0.9)", overflow:
          "scroll"
      }}>
        <PayAndRegister />
      </div>
    )
  }*/


  /* Ask for a confirmation of this plan and save plan details */
  if (selectedBundle && selectedBundle.price === 0) {
    return (
      <div className="modal" tabIndex="-1" role="dialog" aria-hidden="true" style={{
          display: "block", background: "rgba(0,0,0,0.9)", overflow: "scroll"
        }}>
        <div className="modal-dialog" role="document">
            <div className="modal-content">
                <div className="modal-header relative">
                  <h5 className="modal-title">
                      Confirm Plan Selection
                  </h5>
                  <button type="button" className="close absolute" data-dismiss="modal" aria-label="Close"
                          onClick={() => selectBundle(null)}
                          style={{
                                top: 10,
                                right: 10,
                          }}
                  >
                      <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div className="modal-body">
                    <p>
                        Are you sure you want to select <strong>{selectedBundle.name}</strong>?
                    </p>
                    <p className="text-sm mt-2">
                        You will be charged based on the number of employees in all of your linked accounts.
                        A bill summary is issued on the 20th of each month, with the credit card on file charged on the 24th of the month.
                    </p>
                    <button className="btn btn-primary" onClick={() => {
                        updateAdvisorDetails({
                        	id: advisorId,
                        	detailsToUpdate: {
                        		plan: selectedBundle.id,
                                trialExpires: null,
                        	},
                        });
                    }}>
                        Yes, Proceed with {selectedBundle.name}
                    </button>
                </div>
            </div>
        </div>
      </div>
    );
  }

  if (selectedBundle) {
    return (
      <div className="modal" tabIndex="-1" role="dialog" aria-hidden="true" style={{
        display: "block", background: "rgba(0,0,0,0.9)", overflow:
          "scroll"
      }}>
        <PaymentMethods advisorCharge={true}/>
      </div>
    )
  }

  return (
    <div className="modal" tabIndex="-1" role="dialog" aria-hidden="true" style={{
      display: "block", background: "rgba(0,0,0,0.9)", overflow:
        "scroll"
    }}>

      <div
        style={{
          color: "white",
          position: "absolute",
          top: 15,
          right: 15,
          cursor: "pointer",
        }}
        onClick={() => {
          localStorage.setItem('ignoreInsufficientCredits', new Date().getTime() + 2 * 60 * 60 * 1000)
          closeModal()
        }}>
        <XMarkIcon className="h-6 w-6 mr-3 text-white" />
      </div>

      <section className="billing-page">
        <div
          style={{
            top: "50%",
            marginLeft: "10%",
            marginRight: "10%",
            width: '80%',
            transform: "translateY(-50%)",
            position: "absolute",
          }}>
          {/*<div className="grid grid-cols-3 gap-8">
            {(isAdvisor ? advisorBundles: bundles)?.map(bundle =>
              <BundleCard key={bundle.id} bundle={bundle} />
            )}
          </div>*/}


            <div className="grid grid-cols-2 gap-8">
              {
                advisorBundles?.map?.(bundle =>
                  <AdvisorBundleCard key={bundle.id} bundle={bundle} />
                )
              }
            </div>
        </div>

      </section>


    </div>
  )
}

const mapStateToProps = (state) => {
  const stats = state.payment.stats
  const { currency, plan, org, planRenewalDate, trialExpires } = { ...state.advisors?.settings }

  const modalState = state.payment.advisorModal
  const isNew = state.payment.isNew

  // show the modal if the plan is set and expired or the trial is expired
  let showModal = ((planRenewalDate || trialExpires) && (planRenewalDate ?? trialExpires) < format(new Date(), 'yyyy-MM-dd')) || (state.payment?.creditId) || modalState

  const bundles = state.payment.bundles && _.orderBy(state.payment.bundles?.filter(b =>
      b.isPlan && b.advisor != 'yes' && b.availableTo >= new Date().toISOString() && b.availableFrom <= new Date().toISOString()
  ), ['credits'], ['asc'])?.map(item => {
    const current = item.id == state.advisors?.settings?.plan
    return {
      ...item,
      current,
      value: item.id,
      label: `${item.name} - ${currency}${item.price}/employee/mo`,
    }
  })

  const advisorBundles = state.payment.bundles && _.orderBy(state.payment.bundles?.filter(b =>
      !b.isPlan && b.advisor == true && b.availableTo >= new Date().toISOString() && b.availableFrom <= new Date().toISOString()
  ), ['price'], ['asc'])?.map(item => {
    const current = item.id == state.advisors?.settings?.plan
    return {
      ...item,
      current,
      value: item.id,
      label: `${item.name} - ${currency}${item.price}/employee/mo`,
    }
  })

  // suggested Bundle
  let recommended = false

  if (!recommended && bundles) {
    recommended = bundles[bundles.length]
  }

  return {
    showModal,
    bundles,
    advisorBundles,
    recommended,
    selectedBundle: state.payment.selectedBundle,
    currency,
    isAdvisor: state.my?.profile?.isAdvisor && state.my?.profile?.advisorUnlimited && state.advisors?.settings?.advisor,
    advisorId: state.my?.profile?.advisorId,
  }
}

const mapDispatchToProps = dispatch => ({
  getBundles: () => dispatch(PAYMENTACTIONS.getBundles()),
  closeModal: () => dispatch(ADVISORACTIONS.showPricingModal(null)),
  selectBundle: (bundle) => dispatch(PAYMENTACTIONS.selectBundle(bundle)),
	updateAdvisorDetails: (details) => dispatch(ADVISORACTIONS.updateAdvisorDetails(details)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AdvisorChoosePlan)
